<div [class]="styleClass">
    <ng-content></ng-content>
</div>
